import { createPortal } from 'react-dom'

interface PortalProps {
  children: React.ReactNode;
  container?: HTMLElement;
  enabled?: boolean;
}

export function Portal ({
  children,
  container = document.body,
  enabled = true,
}: PortalProps) {
  if (!enabled) return children

  return createPortal(children, container)
}
